import React, { useState, useEffect } from 'react';

import { getKafkaOutgoingMessages } from '@go-client/lib/api/kafkaLogger';

import './KafkaOutgoingMessagesLog.scss';
import { LoadingIndicator } from '@spark-labs/avocado-ui/dist/components/LoadingIndicator';
import { InlineIcon } from '@spark-labs/avocado-ui';
// tslint:disable-next-line:max-line-length
import { KafkaOutgoingMessagesHeader } from '@go-client/components/KafkaControl/KafkaOutgoingMessages/KafkaOutgoingMessagesHeader/KafkaOutgoingMessagesHeader';
import { OutgoigMessagePayload, KafkaOutgoingMessagesFilters } from '@go-shared/types/kafkaLogs';
import { RouteComponentProps } from 'react-router';
// tslint:disable-next-line:max-line-length
import { KafkaOutgoingMessages } from '@go-client/components/KafkaControl/KafkaOutgoingMessages/KafkaOutgoingMessages';

/**
 *
 * I don't want to name my props `RouteComponentProps``
 * I want a declarative name for my interface even if
 * is empty I don't want to use the supertype
 *
 * */
// tslint:disable-next-line
interface KafkaOutgoingMessagesLogProps extends RouteComponentProps {}
const KafkaOutgoingMessagesLog: React.FC<KafkaOutgoingMessagesLogProps> = () => {
  const [retrievedMessages, setRetrievedMessages] = useState<OutgoigMessagePayload[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    getFilteredOutgoingMessages().then().catch(console.error);
  }, []);

  const getFilteredOutgoingMessages = async (filters?: KafkaOutgoingMessagesFilters) => {
    try {
      const { messages } = await getKafkaOutgoingMessages(filters);
      setRetrievedMessages(messages);
    } catch (e) {
      setRetrievedMessages([]);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <main className="w-full h-full">
      <div className="align-with-logo items-baseline">
        <KafkaOutgoingMessagesHeader
          onFiltersChange={filters => getFilteredOutgoingMessages(filters)}
        />
      </div>
      {isLoading ? (
        <div className="content-minus-logo items-center flex justify-center w-full">
          <LoadingIndicator />
        </div>
      ) : retrievedMessages && retrievedMessages.length !== 0 ? (
        <KafkaOutgoingMessages messages={retrievedMessages} />
      ) : (
        <EmptyLogs />
      )}
    </main>
  );
};

const EmptyLogs = () => {
  return (
    <div className="content-minus-logo empty-records justify-center items-center flex">
      <div className="message-wrapper">
        <span className="empty-icon flex justify-center">
          <InlineIcon name="bell" className="text-blue-light text-center" />
        </span>
        <h2 className="text-center text-blue-light mt-6 mb-8 font-normal">
          There are no messages available for your search
        </h2>
      </div>
    </div>
  );
};
export default KafkaOutgoingMessagesLog;
